export class DirectDebit {
    constructor({
        directDebitID = 0,
        accountName = '',
        bsb = '',
        accountNumber = '',
        financialInstitutionName = '',
        financialInstitutionBranch = ''
    } = {}) {
        this.directDebitID = directDebitID;
        this.accountName = accountName;
        this.bsb = bsb;
        this.accountNumber = accountNumber;
        this.financialInstitutionBranch = financialInstitutionBranch;
        this.financialInstitutionName = financialInstitutionName;

    }
}

export function CreateDirectDebit(data) {
    return Object.freeze(new DirectDebit(data))
}

